const initState = () => {
  return {
    showCreateContactModal: false,
  };
}

const client = (state=initState(), action) => {
  switch (action.type) {
    case "CLEAR_CLIENT":
      return initState();

    case "SET_CREATE_CONTACT_MODAL":
      return {...state, ...{showCreateContactModal: action.payload}};

    case "UPDATE_CLIENT_NOTES":
      return {...state, ...{notes: action.payload}};
  
    case "UPDATE_CLIENT_AVATAR":
      const updateAvatar = `${state.avatar}?${new Date().getTime()}`;
      return {...state, ...{avatar: updateAvatar}};

    case "INIT_CLIENT":
      return {
        ...state,
        ...action.payload,
        ...{avatar: `${action.payload.avatar}?${new Date().getTime()}`},
        ...{contacts: action.payload.contacts.map(i => {
          return {
            ...i,
            ...{avatar: `${i.avatar}?${new Date().getTime()}`}
          }
        })}
      };

    default:
      return state;
  }
}

export default client;
